import { render, staticRenderFns } from "./CheckableHead.vue?vue&type=template&id=354f2ed2&"
import script from "./CheckableHead.vue?vue&type=script&lang=js&"
export * from "./CheckableHead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports